function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["elements", "name", "label", "labelProps", "contentProps", "style", "className", "collapsable", "defaultCollapsed"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useContext, useEffect } from 'react';
import { Col, Divider, Row } from 'antd';
import Element from "../element";
import FormContext from "../../form-context";
import StepContext from "../../form-step-context";
import { calcNamePath, calcFormItemProps } from "../../utils/form-utils";
import Typography from "../../typography";
import { ArrowDownOutlined, ArrowUpOutlined } from 'iglooicon';
import classnames from 'classnames';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Section = function Section(_ref) {
  var parentName = _ref.parentName,
    _ref$config = _ref.config,
    _ref$config$elements = _ref$config.elements,
    elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
    name = _ref$config.name,
    label = _ref$config.label,
    _ref$config$labelProp = _ref$config.labelProps,
    labelProps = _ref$config$labelProp === void 0 ? {} : _ref$config$labelProp,
    _ref$config$contentPr = _ref$config.contentProps,
    contentProps = _ref$config$contentPr === void 0 ? {} : _ref$config$contentPr,
    _ref$config$style = _ref$config.style,
    style = _ref$config$style === void 0 ? {} : _ref$config$style,
    className = _ref$config.className,
    _ref$config$collapsab = _ref$config.collapsable,
    collapsable = _ref$config$collapsab === void 0 ? false : _ref$config$collapsab,
    _ref$config$defaultCo = _ref$config.defaultCollapsed,
    defaultCollapsed = _ref$config$defaultCo === void 0 ? false : _ref$config$defaultCo,
    rest = _objectWithoutProperties(_ref$config, _excluded),
    preview = _ref.preview,
    disabled = _ref.disabled,
    setShowStepButton = _ref.setShowStepButton;
  var _useState = useState(defaultCollapsed && !preview),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    toggle = _useState2[1];
  var _useContext = useContext(FormContext),
    form = _useContext.form,
    requiredMark = _useContext.requiredMark,
    validationCodeExtraParams = _useContext.validationCodeExtraParams;
  var _useContext2 = useContext(StepContext),
    registerSection = _useContext2.registerSection;
  var namePath = calcNamePath(parentName, name);
  useEffect(function () {
    if (collapsable) {
      registerSection(namePath, function (collapsed) {
        return toggle(collapsed);
      });
    }
  }, []);
  var _calcFormItemProps = calcFormItemProps(rest, {
      requiredMark: requiredMark
    }, form, parentName, validationCodeExtraParams),
    formItemProps = _calcFormItemProps.formItemProps,
    elementProps = _calcFormItemProps.elementProps,
    display = _calcFormItemProps.display;
  if (formItemProps.copiedValue.copied) {
    var currentValue = form === null || form === void 0 ? void 0 : form.getFieldValue(namePath);
    var value = _objectSpread(_objectSpread({}, currentValue), formItemProps.copiedValue.value);
    form === null || form === void 0 ? void 0 : form.setFields([{
      name: namePath,
      value: value,
      errors: []
    }]);
  }
  return display ? /*#__PURE__*/_jsxs(Col, {
    span: 24,
    className: classnames('igloo-section', className),
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      className: 'igloo-section-label',
      onClick: function onClick() {
        collapsable && !preview && toggle(function (c) {
          return !c;
        });
      },
      children: [label && /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, labelProps), {}, {
        level: "h4",
        wrapElement: "div",
        children: label
      })), collapsable && !preview && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ArrowDownOutlined, {
          style: {
            opacity: collapsed ? 0 : 1,
            fontSize: 24,
            display: collapsed ? 'none' : 'block'
          }
        }), /*#__PURE__*/_jsx(ArrowUpOutlined, {
          style: {
            opacity: collapsed ? 1 : 0,
            fontSize: 24,
            display: collapsed ? 'block' : 'none'
          }
        })]
      })]
    }), collapsable && !preview && /*#__PURE__*/_jsx(Divider, {
      className: "igloo-section-collapse-divider"
    }), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      className: 'igloo-section-content'
    }, contentProps), {}, {
      style: {
        display: !collapsable || !collapsed ? 'block' : 'none'
      },
      children: /*#__PURE__*/_jsx(Row, {
        gutter: [32, preview ? 16 : 24],
        children: elements.map(function (child, index) {
          return /*#__PURE__*/_jsx(Element, {
            parentName: namePath,
            config: child,
            disabled: elementProps.disabled || disabled,
            preview: preview,
            setShowStepButton: setShowStepButton
          }, index);
        })
      })
    }))]
  }) : null;
};
export default Section;